// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "c32c4e5f",
    "hash": "c32c4e5f",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "c32c4e5f",
    "semverString": null,
    "version": "1.0.0"
};
/* tslint:enable */
